import { Action } from '@ngrx/store';
import { CompanyEmployeeOverviewPageParams, LoadCompanyEmployeeOverviewPage } from '../actions/company-employee.actions';

export function toOverviewPageReload(companyId: string, lastParams: CompanyEmployeeOverviewPageParams | null): Action[] {
    return lastParams && lastParams.companyId === companyId ? [LoadCompanyEmployeeOverviewPage({ params: lastParams })] : [];
}
